"use client";

declare global {
    interface Window {
        gtag?: (...args: unknown[]) => void;
        dataLayer?: Record<string, unknown>[];
    }
}

import Cookies from "js-cookie";
import { CONSENT_COOKIE_NAME, CONSENT_VERSION, type ConsentState } from "./types";

/** Cookie expiry in days (12 months) */
const COOKIE_EXPIRY_DAYS = 365;

/**
 * Read the consent cookie. Returns null if no cookie or version mismatch.
 */
export function getConsent(): ConsentState | null {
    const raw = Cookies.get(CONSENT_COOKIE_NAME);
    if (!raw) return null;

    try {
        const parsed: ConsentState = JSON.parse(raw);
        if (parsed.version !== CONSENT_VERSION) return null;
        return parsed;
    } catch {
        return null;
    }
}

/**
 * Write the consent cookie and fire GTM consent update signals.
 */
export function setConsent(analytics: boolean, marketing: boolean): ConsentState {
    const state: ConsentState = {
        analytics,
        marketing,
        timestamp: new Date().toISOString(),
        version: CONSENT_VERSION,
    };

    Cookies.set(CONSENT_COOKIE_NAME, JSON.stringify(state), {
        expires: COOKIE_EXPIRY_DAYS,
        secure: process.env.NODE_ENV === "production",
        sameSite: "lax",
        path: "/",
    });

    // Fire GTM Consent Mode update
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("consent", "update", {
            analytics_storage: analytics ? "granted" : "denied",
            ad_storage: marketing ? "granted" : "denied",
            ad_personalization: marketing ? "granted" : "denied",
            ad_user_data: marketing ? "granted" : "denied",
        });
    }

    return state;
}
